module.exports = __webpack_public_path__ + "assets/img/upload-logo-zh.e94a2366.png";